import { createAction } from '@reduxjs/toolkit';
import {
  TCheckDynamicCatalogDataProps,
  TGetObjectionNextStepProps,
  TGetReportProps,
  TGetReportSettingsProps,
} from '../types';

export const getReportsList = createAction('reportBuilder/editPartnerAction');

export const getObjectionNextStep = createAction<TGetObjectionNextStepProps>(
  'reportBuilder/getObjectionNextStep',
);

export const getReportSettings = createAction<TGetReportSettingsProps>(
  'reportBuilder/getReportSettings',
);

export const checkDynamicCatalogData =
  createAction<TCheckDynamicCatalogDataProps>(
    'reportBuilder/checkDynamicCatalogData',
  );

export const getReport = createAction<TGetReportProps>(
  'reportBuilder/getReport',
);
